import React, { Component } from 'react';
import ImageSliderPixi from './ImageSliderPixi';

class ImageSlider extends Component {
  isSetup = false;
  componentDidMount() {
    if (this.props.display && !this.isSetup) {
      this.setup();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.display && !prevProps.display && !this.isSetup) {
      this.setup();
    }
  }
  setup() {
    this.isSetup = true;
    // create pixi slider
    const imgSrcs = this.props.images.map(imgData => imgData.sizes.large);
    console.log(
      'pixi size',
      this.pixiContainer.offsetWidth,
      this.pixiContainer.offsetHeight
    );
    this.imageSlider = new ImageSliderPixi(
      this.pixiContainer,
      imgSrcs,
      this.pixiContainer.offsetWidth,
      this.pixiContainer.offsetHeight
    );
    this.props.registerNextListener(this.imageSlider.nextSlide);
    this.props.registerPrevListener(this.imageSlider.prevSlide);
    this.props.registerOpenListener(this.imageSlider.open);
    this.props.registerCloseListener(this.imageSlider.close);
    this.props.registerCloseSectionListener(this.imageSlider.closeSection);

    window.addEventListener('resize', this.resizePixi);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resizePixi);
    if (this.imageSlider && this.imageSlider.app) {
      this.imageSlider.app.destroy(true, { children: true });
    }
  }
  resizePixi = () => {
    this.imageSlider.updatePixiSize(
      this.pixiContainer.offsetWidth,
      this.pixiContainer.offsetHeight
    );
  };
  render() {
    return (
      <div
        ref={el => {
          this.pixiContainer = el;
        }}
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          left: 0,
          top: 0,
          pointerEvents: 'none',
        }}
      />
    );
  }
}

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/components/PixiPressPlay/ImageSlider.js